export const freePlans = ['no_plan']
